import { Toast } from 'zarm';
import config from '../../config';
import fetchAPI from '../../utils/fetchAPI';
import { getFormId, toTrim } from '../../utils/tools';
import { SearchProps, cityProps } from './type';

const getValue = (props, defaultValue: string | number = ''): string | number =>{
    if (typeof props.value !== 'undefined' && props.value !== null) {
        return props.value;
    }
    if (typeof props.defaultValue !== 'undefined' && props.defaultValue !== null) {
        return props.defaultValue;
    }
    return defaultValue;
};

function exportCityObj(props: SearchProps, callback) {
    const {
        sourceName = 'city',
        _crengine,
    } = props;
    const { form, path } = _crengine || {};
    if (form) {
        const names = getFormId(sourceName, path);
        const city = form.getFieldValue(names);

        if (Object.prototype.toString.call(city) === '[object Object]') {
            return callback && callback(city);
        }
        return null;
    }
    console.error('address 组件必须有form');
    return null;
}

function getCityFromProps(props: SearchProps) {
    return exportCityObj(props, (city: cityProps) => {
        return city.label;
    });
}

const getAddressOptions = (props: SearchProps, keyword: string = '', callback) => {
    const { fetch } = props;
    let fetchParams = {
        url: `${config.iybtm.host}/util/zone/sketch.json`,
        method: 'POST',
        data: {},
    };
    if (fetch) {
        fetchParams = Object.assign(fetchParams, fetch);
    }
    if (keyword === '' || toTrim(keyword).toString() === '') {
        return [];
    }
    exportCityObj(props, (city: cityProps) => {
        fetchParams.data = {
            keyword,
            city,
        };
        fetchAPI
            .fetchResult(fetchParams)
            .then((content: any) => {
                const { code, message, result } = content;
                if (+code === 0 && result) {
                    if (result && result.addressList) {
                        return callback && callback(result.addressList);
                    }
                    Toast.show('接口返回没有addressList字段');
                } else {
                    message && Toast.show(message);
                }
            })
            .catch((message: string) => {
                message && Toast.show(message);
            });
    });
};

export {
    getCityFromProps,
    getAddressOptions,
    getValue,
};
